(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-cookie-consent]');
    if (!root) return;

    const STORAGE_KEY = 'irishtech_cookie_consent_v1';
    const overlay = root.querySelector('[data-cookie-overlay]');
    const notice = root.querySelector('[data-cookie-notice]');
    const prefs = root.querySelector('[data-cookie-prefs]');
    const analyticsInput = root.querySelector('[data-cookie-analytics]');
    const marketingInput = root.querySelector('[data-cookie-marketing]');
    const functionalInput = root.querySelector('[data-cookie-functional]');

    let gateRequired = false;

    const defaultConsent = () => ({
      necessary: true,
      analytics: false,
      marketing: false,
      functional: false,
      timestamp: null,
    });

    const readConsent = () => {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !parsed.timestamp) return null;
        return {
          necessary: true,
          analytics: Boolean(parsed.analytics),
          marketing: Boolean(parsed.marketing),
          functional: Boolean(parsed.functional),
          timestamp: parsed.timestamp,
        };
      } catch (error) {
        return null;
      }
    };

    const applyConsentDatasets = (consent) => {
      document.documentElement.dataset.cookieAnalytics = consent.analytics ? 'true' : 'false';
      document.documentElement.dataset.cookieMarketing = consent.marketing ? 'true' : 'false';
      document.documentElement.dataset.cookieFunctional = consent.functional ? 'true' : 'false';
    };

    const writeConsent = (consent) => {
      const payload = {
        ...consent,
        necessary: true,
        timestamp: new Date().toISOString(),
      };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      applyConsentDatasets(payload);
      document.dispatchEvent(new CustomEvent('cookie-consent:updated', { detail: payload }));
      return payload;
    };

    const fillPrefs = (consent) => {
      if (analyticsInput) analyticsInput.checked = Boolean(consent.analytics);
      if (marketingInput) marketingInput.checked = Boolean(consent.marketing);
      if (functionalInput) functionalInput.checked = Boolean(consent.functional);
    };

    const lockPage = () => {
      document.documentElement.classList.add('cookie-consent-locked');
    };

    const unlockPage = () => {
      document.documentElement.classList.remove('cookie-consent-locked');
    };

    const setStep = (step) => {
      if (overlay) overlay.dataset.cookieStep = step;
    };

    const showNotice = () => {
      setStep('notice');
      if (notice) notice.hidden = false;
      if (prefs) prefs.hidden = true;
    };

    const showPrefs = () => {
      setStep('prefs');
      fillPrefs(readConsent() || defaultConsent());
      if (notice) notice.hidden = true;
      if (prefs) prefs.hidden = false;
      window.requestAnimationFrame(() => {
        root.querySelector('[data-cookie-save]')?.focus();
      });
    };

    const openGate = ({ required, step }) => {
      gateRequired = Boolean(required);
      root.hidden = false;
      lockPage();
      if (step === 'prefs') {
        showPrefs();
      } else {
        showNotice();
        window.requestAnimationFrame(() => {
          root.querySelector('[data-cookie-accept]')?.focus();
        });
      }
    };

    const closeGate = () => {
      if (gateRequired) return;
      root.hidden = true;
      unlockPage();
      showNotice();
    };

    const completeChoice = (consent) => {
      writeConsent(consent);
      gateRequired = false;
      root.hidden = true;
      unlockPage();
      showNotice();
    };

    const acceptAll = () => {
      completeChoice({
        necessary: true,
        analytics: true,
        marketing: true,
        functional: true,
      });
    };

    const rejectOptional = () => {
      completeChoice(defaultConsent());
    };

    const savePrefs = () => {
      completeChoice({
        necessary: true,
        analytics: Boolean(analyticsInput?.checked),
        marketing: Boolean(marketingInput?.checked),
        functional: Boolean(functionalInput?.checked),
      });
    };

    root.querySelectorAll('[data-cookie-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        event.preventDefault();
        const item = toggle.closest('[data-cookie-accordion]');
        if (!item) return;
        const open = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    root.querySelectorAll('[data-cookie-accept]').forEach((btn) => {
      btn.addEventListener('click', acceptAll);
    });
    root.querySelectorAll('[data-cookie-reject]').forEach((btn) => {
      btn.addEventListener('click', rejectOptional);
    });
    root.querySelector('[data-cookie-manage]')?.addEventListener('click', showPrefs);
    root.querySelector('[data-cookie-save]')?.addEventListener('click', savePrefs);
    root.querySelector('[data-cookie-back]')?.addEventListener('click', () => {
      if (gateRequired) {
        showNotice();
        return;
      }
      closeGate();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (root.hidden) return;
      if (gateRequired) {
        if (prefs && !prefs.hidden) {
          showNotice();
        }
        event.preventDefault();
        return;
      }
      closeGate();
    });

    const openSettings = (event) => {
      event?.preventDefault();
      openGate({ required: false, step: 'prefs' });
    };

    document.querySelectorAll('[data-cookie-open-settings]').forEach((link) => {
      link.addEventListener('click', openSettings);
    });

    const existing = readConsent();
    if (existing) {
      applyConsentDatasets(existing);
      root.hidden = true;
      unlockPage();
    } else {
      openGate({ required: true, step: 'notice' });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    // Show checkout as the cart flies out (avoids empty button at end of animation)
    const ANIMATION_MS = 3000;
    const CHECKOUT_MS = 15000;

    const addToCart = async (variantId) => {
      const response = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
        }),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Unable to add to cart');
      }

      return response.json();
    };

    const showCheckout = (button) => {
      const actions = button.closest('[data-product-actions]');
      const checkout = actions?.querySelector('[data-product-checkout]');
      if (!checkout) {
        button.classList.remove('is-loading');
        return;
      }

      if (button._checkoutTimer) {
        window.clearTimeout(button._checkoutTimer);
      }

      checkout.hidden = false;
      button.hidden = true;
      button.classList.remove('is-loading');

      button._checkoutTimer = window.setTimeout(() => {
        checkout.hidden = true;
        button.hidden = false;
        button._checkoutTimer = null;
      }, CHECKOUT_MS);
    };

    const bindButton = (button) => {
      if (button.dataset.atcBound) return;
      button.dataset.atcBound = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        if (button.disabled || button.classList.contains('is-loading') || button.hidden) return;

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.classList.add('is-loading');

        try {
          await addToCart(variantId);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          console.error(error);
          button.classList.remove('is-loading');
          return;
        }

        window.setTimeout(() => {
          showCheckout(button);
        }, ANIMATION_MS);
      });
    };

    const init = () => {
      document.querySelectorAll('[data-product-atc]').forEach(bindButton);
    };

    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('product-listing:updated', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-listing"] && !Shopify.designMode) return;
  try {
    if (!document.getElementById('product-listing-scroll-lock')) {
    const style = document.createElement('style');
    style.id = 'product-listing-scroll-lock';
    style.textContent = 'html.product-listing-filters-open, html.product-listing-sort-open { overflow: hidden; }';
    document.head.appendChild(style);
  }
  class ProductListing {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.filtersForm = root.querySelector('[data-product-listing-filters]');
      this.grid = root.querySelector('[data-product-listing-grid]');
      this.loader = root.querySelector('[data-product-listing-loader]');
      this.sentinel = root.querySelector('[data-product-listing-sentinel]');
      this.pagination = root.querySelector('[data-product-listing-pagination]');
      this.countEl = root.querySelector('[data-product-listing-count]');
      this.countElMobile = root.querySelector('[data-product-listing-count-mobile]');
      this.sortInput = root.querySelector('[data-product-listing-sort-input]');
      this.overlay = root.querySelector('[data-product-listing-overlay]');
      this.sidebar = root.querySelector('[data-product-listing-sidebar]');
      this.sortSheet = root.querySelector('[data-product-listing-sort-sheet]');
      this.loading = false;
      this.observer = null;

      this.bindFilters();
      this.bindSort();
      this.bindPrice();
      this.bindSeeMore();
      this.bindSortSheet();
      this.bindMobileFilters();
      this.bindInfiniteScroll();
    }

    bindFilters() {
      if (!this.filtersForm) return;

      let priceTimer;
      this.filtersForm.addEventListener('change', (event) => {
        if (event.target.matches('[data-price-min], [data-price-max]')) return;
        this.applyFilters();
      });

      this.filtersForm.addEventListener('input', (event) => {
        if (!event.target.matches('[data-price-min], [data-price-max]')) return;
        clearTimeout(priceTimer);
        priceTimer = setTimeout(() => this.applyFilters(), 350);
      });
    }

    bindSort() {
      this.root.querySelectorAll('.product-listing__toolbar [data-sort-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const value = button.dataset.sortValue;
          if (this.sortInput) this.sortInput.value = value;
          this.applyFilters({ sort_by: value });
        });
      });
    }

    bindPrice() {
      const wrap = this.root.querySelector('[data-price-range]');
      if (!wrap) return;
      const minInput = wrap.querySelector('[data-price-min]');
      const maxInput = wrap.querySelector('[data-price-max]');
      const fill = wrap.querySelector('[data-price-fill]');
      const minLabel = wrap.querySelector('[data-price-min-label]');
      const maxLabel = wrap.querySelector('[data-price-max-label]');
      const moneyFormat = this.root.dataset.moneyFormat || '';

      const formatMoney = (cents) => {
        const amount = (Number(cents) / 100).toFixed(0);
        if (moneyFormat) {
          return moneyFormat
            .replace(/\{\{.*?\}\}/, amount)
            .replace(/\{\{.*?\}\}/g, '');
        }
        return `$${amount}`;
      };

      const sync = () => {
        let min = Number(minInput.value);
        let max = Number(maxInput.value);
        const range = Number(wrap.dataset.rangeMax) || 0;
        if (min > max) {
          if (document.activeElement === minInput) max = min;
          else min = max;
          minInput.value = String(min);
          maxInput.value = String(max);
        }
        const left = range ? (min / range) * 100 : 0;
        const right = range ? (max / range) * 100 : 100;
        if (fill) {
          fill.style.marginLeft = `${left}%`;
          fill.style.width = `${Math.max(0, right - left)}%`;
        }
        if (minLabel) minLabel.textContent = formatMoney(min);
        if (maxLabel) maxLabel.textContent = formatMoney(max);
      };

      minInput.addEventListener('input', sync);
      maxInput.addEventListener('input', sync);
      sync();
    }

    bindSeeMore() {
      const toggleExtras = (button, listSelector) => {
        if (!button) return;
        button.addEventListener('click', () => {
          const list = this.root.querySelector(listSelector);
          if (!list) return;
          const extras = list.querySelectorAll('.is-extra');
          const expanded = button.dataset.expanded === 'true';
          extras.forEach((item) => {
            item.hidden = expanded;
          });
          button.dataset.expanded = expanded ? 'false' : 'true';
          button.textContent = expanded
            ? button.dataset.moreLabel || button.textContent
            : button.dataset.lessLabel || 'See less';
        });
      };

      const catMore = this.root.querySelector('[data-category-more]');
      if (catMore) {
        catMore.dataset.moreLabel = catMore.textContent;
        catMore.dataset.lessLabel = 'See less';
      }
      toggleExtras(catMore, '[data-category-list]');

      const vendorMore = this.root.querySelector('[data-vendor-more]');
      if (vendorMore) {
        vendorMore.dataset.moreLabel = vendorMore.textContent;
        vendorMore.dataset.lessLabel = 'See less';
      }
      toggleExtras(vendorMore, '[data-vendor-list]');
    }

    bindSortSheet() {
      const openBtn = this.root.querySelector('[data-product-listing-open-sort]');
      this.closeSortSheet = () => {
        this.root.classList.remove('is-sort-open');
        document.documentElement.classList.remove('product-listing-sort-open');
        if (this.sortSheet?.open) this.sortSheet.close();
      };
      this.openSortSheet = () => {
        this.closeFilters?.();
        this.root.classList.add('is-sort-open');
        document.documentElement.classList.add('product-listing-sort-open');
        if (this.sortSheet && !this.sortSheet.open) this.sortSheet.showModal();
      };
      openBtn?.addEventListener('click', () => this.openSortSheet());
      this.sortSheet?.addEventListener('close', () => {
        this.root.classList.remove('is-sort-open');
        document.documentElement.classList.remove('product-listing-sort-open');
      });
      this.sortSheet?.addEventListener('cancel', () => {
        this.root.classList.remove('is-sort-open');
        document.documentElement.classList.remove('product-listing-sort-open');
      });
      this.sortSheet?.querySelectorAll('[data-sort-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.sortValue;
          if (this.sortInput) this.sortInput.value = value;
          this.closeSortSheet();
          this.applyFilters({ sort_by: value });
        });
      });
    }

    syncOverlay() {
      if (!this.overlay) return;
      const open = this.root.classList.contains('is-filters-open');
      this.overlay.hidden = !open;
    }

    bindMobileFilters() {
      const openBtn = this.root.querySelector('[data-product-listing-open-filters]');
      const closeBtn = this.root.querySelector('[data-product-listing-close-filters]');
      this.closeFilters = () => {
        this.root.classList.remove('is-filters-open');
        document.documentElement.classList.remove('product-listing-filters-open');
        this.syncOverlay();
      };
      this.openFilters = () => {
        this.closeSortSheet?.();
        this.root.classList.add('is-filters-open');
        document.documentElement.classList.add('product-listing-filters-open');
        this.syncOverlay();
      };
      openBtn?.addEventListener('click', () => this.openFilters());
      closeBtn?.addEventListener('click', () => this.closeFilters());
      this.overlay?.addEventListener('click', () => {
        this.closeFilters();
        this.closeSortSheet();
      });
    }

    bindInfiniteScroll() {
      if (!this.sentinel || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    nextUrl() {
      const link = this.pagination?.querySelector('[data-product-listing-next]');
      return link?.href || null;
    }

    async loadNextPage() {
      const url = this.nextUrl();
      if (!url || this.loading) return;
      this.loading = true;
      if (this.loader) this.loader.hidden = false;

      try {
        const next = new URL(url, window.location.origin);
        next.searchParams.delete('phcursor');
        next.searchParams.set('section_id', this.sectionId);
        const response = await fetch(next.toString());
        if (!response.ok) throw new Error('Failed to load more products');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('[data-product-listing]');
        const newGrid = newRoot?.querySelector('[data-product-listing-grid]');
        const newPagination = newRoot?.querySelector('[data-product-listing-pagination]');
        const newCount = newRoot?.querySelector('[data-product-listing-count]');

        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => {
            if (child.classList.contains('product-listing__empty')) return;
            this.grid.appendChild(child);
          });
          document.dispatchEvent(new CustomEvent('product-listing:updated'));
        }

        if (newPagination && this.pagination) {
          this.pagination.innerHTML = newPagination.innerHTML;
        }
        if (newCount && this.countEl) {
          this.countEl.innerHTML = newCount.innerHTML;
        }
        const newCountMobile = newRoot?.querySelector('[data-product-listing-count-mobile]');
        if (newCountMobile && this.countElMobile) {
          this.countElMobile.innerHTML = newCountMobile.innerHTML;
        }

        if (!this.nextUrl()) {
          this.sentinel.hidden = true;
          this.observer?.disconnect();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        if (this.loader) this.loader.hidden = true;
      }
    }

    buildParams(extra = {}) {
      const params = new URLSearchParams(new FormData(this.filtersForm));
      Object.entries(extra).forEach(([key, value]) => {
        if (value == null || value === '') params.delete(key);
        else params.set(key, value);
      });
      params.delete('page');
      params.delete('phcursor');
      params.delete('section_id');
      return params;
    }

    async applyFilters(extra = {}) {
      if (this.loading) return;
      this.loading = true;
      if (this.loader) this.loader.hidden = false;

      const params = this.buildParams(extra);
      const url = new URL(window.location.pathname, window.location.origin);
      params.forEach((value, key) => url.searchParams.append(key, value));
      const renderUrl = new URL(url);
      renderUrl.searchParams.set('section_id', this.sectionId);

      try {
        const response = await fetch(renderUrl.toString());
        if (!response.ok) throw new Error('Failed to filter products');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('[data-product-listing]');
        if (!newRoot) throw new Error('Missing listing markup');

        this.root.replaceWith(newRoot);
        history.pushState({}, '', url.toString());
        initProductListings(newRoot);
      } catch (error) {
        console.error(error);
        window.location.href = url.toString();
      }
    }
  }

  const initProductListings = (scope = document) => {
    const roots = scope.matches?.('[data-product-listing]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-product-listing]'));
    roots.forEach((root) => {
      if (root.dataset.plReady) return;
      root.dataset.plReady = 'true';
      new ProductListing(root);
    });
  };

  initProductListings();
  document.addEventListener('shopify:section:load', (event) => initProductListings(event.target));
  window.addEventListener('popstate', () => window.location.reload());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-buy"] && !Shopify.designMode) return;
  try {
    class ProductQuickBuy {
    constructor(dialog) {
      this.dialog = dialog;
      this.priceEl = dialog.querySelector('[data-quick-buy-price]');
      this.compareEl = dialog.querySelector('[data-quick-buy-compare]');
      this.errorEl = dialog.querySelector('[data-quick-buy-error]');
      this.addBtn = dialog.querySelector('[data-quick-buy-add-to-cart]');
      this.buyBtn = dialog.querySelector('[data-quick-buy-buy-now]');
      this.qtyInput = dialog.querySelector('[data-quick-buy-qty-input]');
      this.optionInputs = Array.from(dialog.querySelectorAll('[data-quick-buy-option-index]'));
      this.slides = Array.from(dialog.querySelectorAll('[data-quick-buy-slide]:not([data-quick-buy-variant-slide])'));
      this.variantSlide = dialog.querySelector('[data-quick-buy-variant-slide]');
      this.variantImage = dialog.querySelector('[data-quick-buy-variant-image]');
      this.dots = Array.from(dialog.querySelectorAll('[data-quick-buy-dot]'));
      this.dotsWrap = dialog.querySelector('[data-quick-buy-dots]');
      this.moneyFormat = dialog.dataset.moneyFormat || '{{amount}}';
      this.soldOutLabel = dialog.dataset.soldOutLabel || 'Sold out';
      this.unavailableLabel = dialog.dataset.unavailableLabel || 'Unavailable';
      this.variants = this.parseVariants();
      this.currentVariant = this.variants.find((variant) => variant.available) || this.variants[0] || null;
      this.slideIndex = 0;

      dialog.querySelector('[data-quick-buy-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('product-quick-buy-open');
        this.unbindViewport();
      });
      dialog.addEventListener('product-quick-buy:open', () => {
        this.bindViewport();
        this.syncViewport();
      });

      this._onViewportChange = () => this.syncViewport();

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.syncVariant());
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goToSlide(Number(dot.dataset.index) || 0));
      });

      dialog.querySelector('[data-quick-buy-qty-decrease]')?.addEventListener('click', () => this.changeQty(-1));
      dialog.querySelector('[data-quick-buy-qty-increase]')?.addEventListener('click', () => this.changeQty(1));
      this.addBtn?.addEventListener('click', () => this.submit('cart'));
      this.buyBtn?.addEventListener('click', () => this.submit('checkout'));

      this.syncVariant();
    }

    parseVariants() {
      const node = this.dialog.querySelector('[data-quick-buy-variants]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return [];
      }
    }

    isMobileSheet() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    syncViewport() {
      if (!this.isMobileSheet() || !this.dialog.open) {
        this.dialog.style.removeProperty('--qb-vv-bottom');
        this.dialog.style.removeProperty('--qb-vv-max-height');
        return;
      }

      const vv = window.visualViewport;
      if (!vv) {
        this.dialog.style.setProperty('--qb-vv-bottom', '0px');
        this.dialog.style.setProperty('--qb-vv-max-height', '90svh');
        return;
      }

      const bottomInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      const maxHeight = Math.max(240, vv.height * 0.92);
      this.dialog.style.setProperty('--qb-vv-bottom', `${Math.round(bottomInset)}px`);
      this.dialog.style.setProperty('--qb-vv-max-height', `${Math.round(maxHeight)}px`);
    }

    bindViewport() {
      if (this._viewportBound) return;
      this._viewportBound = true;
      window.visualViewport?.addEventListener('resize', this._onViewportChange);
      window.visualViewport?.addEventListener('scroll', this._onViewportChange);
      window.addEventListener('resize', this._onViewportChange);
    }

    unbindViewport() {
      if (!this._viewportBound) return;
      this._viewportBound = false;
      window.visualViewport?.removeEventListener('resize', this._onViewportChange);
      window.visualViewport?.removeEventListener('scroll', this._onViewportChange);
      window.removeEventListener('resize', this._onViewportChange);
      this.dialog.style.removeProperty('--qb-vv-bottom');
      this.dialog.style.removeProperty('--qb-vv-max-height');
    }

    selectedOptions() {
      const values = [];
      this.optionInputs.forEach((input) => {
        if (!input.checked) return;
        values[Number(input.dataset.quickBuyOptionIndex)] = input.value;
      });
      return values;
    }

    syncVariant() {
      const options = this.selectedOptions();
      this.currentVariant =
        this.variants.find((variant) => {
          const values = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
          return options.every((value, index) => !value || values[index] === value);
        }) || null;

      this.clearError();
      this.updateGallery();

      if (!this.currentVariant) {
        this.setActionsEnabled(false);
        if (this.priceEl) this.priceEl.textContent = this.unavailableLabel;
        if (this.compareEl) this.compareEl.hidden = true;
        return;
      }

      if (this.priceEl) this.priceEl.textContent = this.formatMoney(this.currentVariant.price);

      if (this.compareEl) {
        const compare = this.currentVariant.compare_at_price;
        if (compare && compare > this.currentVariant.price) {
          this.compareEl.hidden = false;
          this.compareEl.textContent = this.formatMoney(compare);
        } else {
          this.compareEl.hidden = true;
          this.compareEl.textContent = '';
        }
      }

      const available = Boolean(this.currentVariant.available);
      this.setActionsEnabled(available);
      if (!available && this.addBtn) this.addBtn.textContent = this.soldOutLabel;
    }

    updateGallery() {
      if (!this.currentVariant) return;

      const mediaId = this.currentVariant.media_id != null ? String(this.currentVariant.media_id) : null;
      const imageUrl = this.currentVariant.featured_image;

      if (mediaId) {
        const matchIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
        if (matchIndex >= 0) {
          this.hideVariantSlide();
          this.goToSlide(matchIndex);
          return;
        }
      }

      if (imageUrl && this.variantSlide && this.variantImage) {
        this.slides.forEach((slide) => slide.classList.remove('is-active'));
        this.dots.forEach((dot) => dot.classList.remove('is-active'));
        if (this.dotsWrap) this.dotsWrap.hidden = true;
        this.variantImage.src = imageUrl;
        this.variantSlide.hidden = false;
        this.variantSlide.classList.add('is-active');
        return;
      }

      this.hideVariantSlide();
      if (this.slides.length) this.goToSlide(this.slideIndex);
    }

    hideVariantSlide() {
      if (!this.variantSlide) return;
      this.variantSlide.hidden = true;
      this.variantSlide.classList.remove('is-active');
      if (this.dotsWrap) this.dotsWrap.hidden = this.slides.length <= 1;
    }

    goToSlide(index) {
      if (!this.slides.length) return;
      this.hideVariantSlide();
      this.slideIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.slideIndex));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.slideIndex));
      if (this.dotsWrap) this.dotsWrap.hidden = this.slides.length <= 1;
    }

    setActionsEnabled(enabled) {
      if (this.addBtn) {
        this.addBtn.disabled = !enabled;
        if (enabled) this.addBtn.textContent = this.dialog.dataset.addLabel || 'Add to cart';
      }
      if (this.buyBtn) this.buyBtn.disabled = !enabled;
    }

    changeQty(delta) {
      if (!this.qtyInput) return;
      const next = Math.max(1, (Number.parseInt(this.qtyInput.value, 10) || 1) + delta);
      this.qtyInput.value = String(next);
    }

    formatMoney(cents) {
      const amount = (Number(cents) / 100).toFixed(2);
      const amountNoDecimals = String(Math.round(Number(cents) / 100));
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }

    async submit(mode) {
      if (!this.currentVariant?.available) return;

      const quantity = Math.max(1, Number.parseInt(this.qtyInput?.value, 10) || 1);
      this.setActionsEnabled(false);
      this.clearError();

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: this.currentVariant.id,
            quantity,
          }),
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Unable to add to cart');
        }

        if (mode === 'checkout') {
          window.location.href = '/checkout';
          return;
        }

        this.dialog.close();
        this.setActionsEnabled(true);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        this.showError(error.message || 'Unable to add to cart');
        this.setActionsEnabled(true);
      }
    }
  }

  const initQuickBuy = () => {
    document.querySelectorAll('[data-product-quick-buy]').forEach((dialog) => {
      if (dialog.dataset.qbReady) return;
      dialog.dataset.qbReady = 'true';
      new ProductQuickBuy(dialog);
    });

    document.querySelectorAll('[data-open-quick-buy]').forEach((button) => {
      if (button.dataset.qbBound) return;
      button.dataset.qbBound = 'true';
      button.addEventListener('click', () => {
        const productId = button.dataset.productId;
        const dialog = document.querySelector(`[data-product-quick-buy][data-product-id="${productId}"]`);
        if (!dialog) return;
        document.documentElement.classList.add('product-quick-buy-open');
        dialog.showModal();
        dialog.dispatchEvent(new CustomEvent('product-quick-buy:open'));
      });
    });
  };

  initQuickBuy();
  document.addEventListener('shopify:section:load', initQuickBuy);
  document.addEventListener('product-listing:updated', initQuickBuy);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const sections = Array.from(document.querySelectorAll('.shopify-section')).filter((section) => {
      if (section.closest('.shopify-section-group-header-group')) return false;
      if (section.classList.contains('hero-banner-section')) return false;
      if (section.classList.contains('featured-products-section')) return false;
      return section.children.length > 0;
    });

    if (!sections.length) return;

    const reveal = (section) => {
      section.classList.add('is-visible');
      const clearWillChange = () => {
        Array.from(section.children).forEach((child) => {
          child.style.willChange = 'auto';
        });
      };
      section.addEventListener('transitionend', clearWillChange, { once: true });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -48px 0px',
      }
    );

    // Ensure initial hidden styles paint before observing, so the transition runs smoothly.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sections.forEach((section) => {
          Array.from(section.children).forEach((child) => {
            child.style.willChange = 'opacity, transform';
          });
          section.classList.add('scroll-reveal');
          observer.observe(section);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
